import './plugins/observability'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { ComponentLibrary } from '@alice-health/wonderland-vue'

createApp(App).use(ComponentLibrary).use(store).use(router).mount('#app')
